const headers = {
  name: "Inventory requested",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
    {
      type: "select",
      name: "sort",
      placeholder: "Sort",
      value: null,
      options: [
        { value: "1", label: "Name (A-Z)" },
        { value: "2", label: "Name (Z-A)" },
        { value: "3", label: "Price (Low)" },
        { value: "4", label: "Price (High)" },
        { value: "5", label: "Balance (Low)" },
        { value: "6", label: "Balance (High)" },
      ],
    },
    {
      type: "filter",
      name: "payment",
      placeholder: "Payment",
      value: null,
      options: [
        { value: 0, label: "Paid" },
        { value: 1, label: "Partial" },
        { value: 2, label: "Unpaid" },
      ],
    },
    {
      type: "filter",
      name: "status",
      placeholder: "Status",
      value: null,
      options: [
        { value: "0", label: "Inactive" },
        { value: "1", label: "Active" },
      ],
    },
    {
      type: "range",
      name: "date",
      value: {
        start: "",
        end: "",
      },
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Batch",
        path: "/app/inventory/",
      },
      {
        name: "Transfer",
        path: "/app/inventory/transfer",
        featureKey: "inventory_transfer_receive"
      },
      {
        name: "Received",
        path: "/app/inventory/received",
        featureKey: "inventory_transfer_receive"
      },
      {
        name: "Request",
        path: "/app/inventory/request",
        featureKey: "inventory_request"
      },
      {
        name: "Requested",
        path: "",
        featureKey: "inventory_request"
      },
    ],
    total: [
      { value: "0", label: "Total" },
      { value: "0", label: "Active" },
      { value: "0", label: "Inactive" },
    ],
  },
};

export default headers;
